import React from 'react'
import SalesMap from '../components/dashboard/SalesMap'
import { ReportPage } from '../components/report-shell'

const SalesMapPage = () => (
  <ReportPage>
    <SalesMap />
  </ReportPage>
)

export default SalesMapPage
